module.exports = __webpack_public_path__ + "static/media/whiteboard.38127290.svg";